import Helper from './Helper';

class Video {
  constructor() {
    const videos = Array.prototype.slice.call(document.querySelectorAll('.ns-video'));

    videos.forEach(video =>{
      const inner = video.querySelector('.ns-video__video');
      const url = inner.innerText;
      const thumbnail = video.querySelector('.ns-video__thumbnail');

      if(!!url){
        let videoplayer = `<video id="video" height="${video.offsetHeight}px" width="100%" preload="auto" src="${url}" controls></video>`
        inner.innerHTML = videoplayer;
        thumbnail.addEventListener('click', () => {
          try{
            videoplayer = video.querySelector('video');
            videoplayer.play();
            thumbnail.classList.add('fade-out');
            thumbnail.style.display = 'none';
          } catch(err){
            alert("Video URL ist fehlerhaft: "+url);
            console.log(err);
          }
        });
      } else{
        thumbnail.addEventListener('click', () => {
          alert("Video URL ist fehlerhaft: "+url);
        }); 
      }

      
    });
  }
} export default Video;
